import CustomBreadcrumbs from 'src/legacy/components/custom-breadcrumbs';
import { useLocales } from 'src/legacy/locales';
import { useSelector } from 'src/legacy/redux/store';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import {
  defaultTabs,
  useFosterFamilyDetailsNavigatorContext,
} from './FosterFamilyDetailsNavigatorContext';

export const Breadcrumbs = () => {
  const { translate } = useLocales();
  const { currentTab } = useFosterFamilyDetailsNavigatorContext();

  const { selectedFosterFamily } = useSelector((state) => state.fosterFamily);

  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label || 'profile';

  return (
    <CustomBreadcrumbs
      heading={selectedFosterFamily?.name || ''}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        {
          href: PATH_DASHBOARD.fosterFamily.root,
          name: `${translate('foster_families')}`,
        },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
